module.exports = __webpack_public_path__ + "img/chalk_11.25b50fc1.png";